import { Href, Link } from "expo-router";
import { SearchIcon } from "lucide-react-native";
import React, { memo } from "react";

import { Box } from "@/components/atoms/Box";
import { Button } from "@/components/atoms/Button";
import { Input } from "@/components/atoms/Input";
import { Stack } from "@/components/atoms/Stack";

/**
 *
 */
interface Props {
  pathname: string;
  isDark: boolean;
}

const buttonMap = {
  Teams: "/player-roster",
  Leagues: "/player-roster/leagues",
};

/**
 * Header view for roster management with Teams/Leagues navigation and search.
 * @param root0 - Component props
 * @param root0.pathname - Current route path to highlight active tab
 * @param root0.isDark - Whether dark theme is active for styling
 */
const HeaderView = ({ pathname, isDark, ...inputProps }: Props) => (
  <Stack className="gap-3 p-3">
    <Stack direction="horizontal" className="gap-3">
      {Object.entries(buttonMap).map(([text, path]) => (
        <Link asChild href={path as Href} key={path} replace>
          <Button
            className={`flex-1 ${pathname === path ? "opacity-70" : ""}`}
            variant="outline"
            isDisabled={pathname === path}
            label={text}
          />
        </Link>
      ))}
    </Stack>
    <Box className="h-12">
      <Input
        size="xl"
        className={`flex-1 ${isDark ? "border-0 border-none bg-background-gray" : "border-surface-strong bg-surface-subtle"} `}
        leadingIcon={SearchIcon}
        field={{
          className: "font-body",
          returnKeyType: "search",
          ...inputProps,
        }}
      />
    </Box>
  </Stack>
);

HeaderView.displayName = "HeaderView";

export default memo(HeaderView);
